import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In `}<strong parentName="p">{`Uganda`}</strong>{`, which hosts the highest number of refugees in Africa, WFP assisted over one million refugees and their host communities in 2019 through monthly cash transfers with support from the EU. This assistance allowed them to choose what food to buy while stimulating economic growth in and around refugee settlements.`}</p>
    <p>{`WFP’s findings show that the element of choice is critical: vulnerable households, which are empowered to decide about their needs, make choices that improve their food security and wellbeing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      